import LightBoxModal from './LightBoxModal';

export default LightBoxModal;
